import { connect } from 'react-redux'

import at from 'lodash/at'
import sortBy from 'lodash/sortBy'

import { fetchLocation } from '../../actions/locations'
import { fetchLabelsForLocation } from '../../actions/servicing-labels'

import ServicingLabelSelector from '../../components/servicing-labels/servicing-label-selector'

const mapStateToProps = (state, ownProps) => {
  const location = state.locations[ownProps.locationId]

  if (!location) return { loading: true }

  const labels = at(state.servicingLabels, location.servicingLabels || [])
  const sortedLabels = sortBy(labels, 'name')

  const options = sortedLabels.map((label) => ({
    value: label.id,
    label: label.name
  }))

  return {
    options
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  dispatch(fetchLocation(ownProps.locationId))
    .then(() => dispatch(fetchLabelsForLocation(ownProps.locationId)))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingLabelSelector)



// WEBPACK FOOTER //
// ./src/containers/servicing-labels/servicing-label-selector-container.js